module.exports = __webpack_public_path__ + "img/img_06.740aee3b.jpg";